<template>
    <div class="legend">
        <DropdownButton class="options-dd-btn">
            <li>
                <div class="toggle" :class="{ off: !legendSort, disabled:chart.filters.chartType === 'growth' &&  chart.filters.breakApart===false }" @click.native.stop>
                        <v-switch background-color="success" v-model="legendSort" @click.native.stop :disabled="chart.filters.chartType === 'growth' &&  chart.filters.breakApart===false"  >
                        </v-switch>
                        <p class="selected-items">Sort by {{(chart.filters.cumulativeType === 'none') ? 'company' : chart.filters.cumulativeType}}</p>
                </div>
            </li>
            <li>
                <div class="toggle" :class="{ off: !showLoe, disabled:isShowLoeDisabled }" @click.native.stop>
                        <v-switch background-color="success" v-model="showLoe" @click.native.stop :disabled="isShowLoeDisabled">
                        </v-switch>
                        <p class="selected-items">Show LOE dates</p>
                </div>
            </li>
            <li>
                <div class="toggle" :class="{ off: !logScale}" @click.native.stop>
                        <v-switch background-color="success" v-model="logScale" @click.native.stop>
                        </v-switch>
                        <p class="selected-items">Log scale</p>
                </div>
            </li>
            <li>
                <div class="toggle" :class="{ off: !showStopIcon}" @click.native.stop>
                        <v-switch background-color="success" v-model="showStopIcon" @click.native.stop>
                        </v-switch>
                        <p class="selected-items">Show stop revenue</p>
                </div>
            </li>
            <li>
                <div class="toggle" :class="{ off: !colorByFicBic, disabled: isColorByFicBicDisabled }" @click.native.stop>
                        <v-switch background-color="success" v-model="colorByFicBic" @click.native.stop :disabled="isColorByFicBicDisabled">
                        </v-switch>
                        <p class="selected-items">Color by FIC/BIC</p>
                </div>
            </li>
        </DropdownButton>

        <VueCustomScrollbar class="legend-inner" :settings="settings">
            <div class="legend-items">

               <div class="legend-item-wrapper legend-item-cumulative"  v-if="chartHasCumulativeRevenueData"
                @click="legendItemClick('cumulative')"
                style="padding-bottom:10px;" >
                    <span class="legend-item-label legend-item-company-name active">Cumulative</span><br>
                    <span class="legend-item legend-item-cumulative active">
                     <span class="legend-item-color" >
                        <svg height="3" width="100%">
                        <g fill="none" stroke="black" stroke-width="5"><path stroke-dasharray="5,5" d="M0 0 l125 0"></path></g>
                        </svg> 
                     </span>
                    </span>
                     </span>
                </div>

                <div class="legend-item-wrapper" v-for="(value,key) in groupedChartLegend">
                    <template
                        v-if="(legendSort  && chart.filters.cumulativeType === 'none')|| chart.filters.chartType === 'growth'  ">
                    <span class="legend-item-company-name active">{{key}}</span><br>
                    <span class="legend-item active" v-for="legend in value" :key="legend.id"
                          :class="`legend-item-${legend.id} ${legend.is_fic_bic_colored ? 'fic-bic-colored' : ''}`"
                          :data-brand-name="legend.brands_name" :data-company-name="legend.company_name">
                    <span :class="['legend-item-label', {
                        'legend-item-removed': legend.name === `${legend.type} removed`
                    }]" 
                    @click="legendItemClick(legend.id)">
                       <span> {{ legend.brands_name }}</span>
                       <template v-if="colorByFicBic && legend.ficBicData && legend.ficBicData.length > 0">
                            <FicBicTag
                                v-for="(data, index) in legend.ficBicData"
                                :key="index"
                                :legend="data"
                                :hasMany="legend.ficBicData.length > 1"
                                :chart="chart"
                                :style="{ 'background-color': getLineColor(legend, index) }"
                            />
                       </template>
                    </span>
                    <LegendItemLoe v-if="showLoe" :chart="chart" :loe_dates="legend.loe_dates" @modifyLoe="(date)=>handleOnModifyLoe(legend.id, date)" />
                    <span class="legend-item-color" :style="{ 'background-color': getLineColor(legend) }" @click="legendItemClick(legend.id)"></span>
                </span>
                    </template>

                    <template  v-else>
                        <span class="legend-item active legend-default-sort" v-for="legend in value" :key="legend.id"
                              :class="`legend-item-${legend.id} ${legend.is_fic_bic_colored ? 'fic-bic-colored' : ''}`"
                              :data-brand-name="legend.brands_name" :data-company-name="legend.company_name">


                       <span :class="['legend-item-label', {
                        'legend-item-removed': legend.name === `${legend.type} removed` }]"
                        @click="legendItemClick(legend.id)">
                        <span> {{ legend.brands_name }}</span>
                        <template v-if="colorByFicBic && legend.ficBicData != null && legend.ficBicData.length > 0">
                            <FicBicTag
                                v-for="(data, index) in legend.ficBicData"
                                :hasMany="legend.ficBicData.length > 1"
                                :key="index"
                                :legend="data"
                                :chart="chart"
                                :style="{ 'background-color': getLineColor(legend, index) }"
                            />
                        </template>
                     </span>
                        <LegendItemLoe v-if="showLoe" :chart="chart" :loe_dates="legend.loe_dates"  @modifyLoe="(date)=>handleOnModifyLoe(legend.id, date)" />

                          <span class="legend-item-color" :style="{ 'background-color': getLineColor(legend) }"
                          @click="legendItemClick(legend.id)"></span>
                        </span>
                    </template>

                </div>
            </div>
        </VueCustomScrollbar>
        <Tooltip position="right" className="loe-tooltip" :autoOpen="false">
            <span></span>
        </Tooltip>  
        <Tooltip position="right" className="legend-tooltip" :autoOpen="false">
            <span></span>
        </Tooltip>
        <div class="legend-more-tag">+ more</div>
    </div>
</template>

<script>
    import filters from '../../../constants/filters';
    import coloringUtil from '../../../utils/coloringUtil';
    import dateUtil from '../../../utils/dateUtil';
    import Tooltip from '../../common/Tooltip.vue';
    import DropdownButton from '../../common/DropdownButton.vue';
    import LegendItemLoe from './LegendItemLoe.vue';
    import FicBicTag from './Legend/FicBicTag.vue';
    import VueCustomScrollbar from 'vue-custom-scrollbar';
    export default {
        components: {
            VueCustomScrollbar,
            Tooltip,
            DropdownButton,
            LegendItemLoe,
            FicBicTag,
        },
        props: {
            chart: {
                type: Object,
            },
            defaultLegendSort:{
                default:false,
            },
            defaultShowLoe:{
                default:false,
            },
            defaultLogScale:{
                default:false,
            },
            defaultShowStopIcon:{
                default:false,
            },
            defaultColorByFicBic:{
                default:false,
            },
        },
        data() {
            return {
                settings: {
                    maxScrollbarLength: 60,
                    suppressScrollX:false,
                    scrollXMarginOffset :50,
                },
                expanded: false,
                showMoreVisible: false,
                ready:false,
                chartLegend: [],
                groupedChartLegend: [],
                legendSort:false,
                showLoe:false,
                logScale: false,
                showStopIcon: false,
                colorByFicBic: false,
            };
        },
        computed: {
            chartHasCumulativeRevenueData() {
                return this.chart.cumulativeData !== undefined 
                        && this.chart.cumulativeData !== null;
            },
            isGrowthRateGraph() {
                return this.chart.filters.chartType === 'growth'
                    && !this.chart.filters.breakApart
                    && !this.chart.filters.viewCompetitors;
            },
            allLinesColors() {
                const type = this.isGrowthRateGraph ? 'growth' : 'revenue';
                return coloringUtil.getAllLinesColors(this.chart.data, type);
            },
            isShowLoeDisabled() {
                return this.chart.filters.chartType === 'growth' ||
                            this.chart.filters.startSyncView ||
                            this.chart.filters.cumulativeType !== 'none' ;
            },
            isColorByFicBicDisabled() {
                return this.chart.filters.chartType === 'growth' ||
                            this.chart.filters.cumulativeType !== 'none' ;
            },
            userSettings() {
                return this.$store.getters['setting/getAll'];
            },
        },
        watch: {
            'chart.filters'() {
                this.getChartLegend();
            },
            legendSort() {
                this.updateLegendSorting();
                this.$store.commit('chart/toggleLegendSort', this.legendSort);
                this.$nextTick(() => {
                    if (this.chart.drawingService) {
                        this.chart.drawingService.handleLinesStateUpdate();
                    }
                });
            }, 
            showLoe() {
                this.$store.commit('chart/toggleShowLoe', this.showLoe);
            },
            logScale() {
                this.$store.commit('chart/toggleLogActive', this.logScale);
            },
            showStopIcon() {
                this.$store.commit('chart/toggleShowStopIcon', this.showStopIcon);
            },
            colorByFicBic() {
                this.$store.commit('chart/toggleColorByFicBic', this.colorByFicBic);
            },
        },
        mounted() {
            this.getChartLegend();
            this.logScale = this.defaultLogScale;
            this.showStopIcon = this.defaultShowStopIcon;
        },
        methods: {
            updateLegendSorting(){

                if(this.legendSort){
                    this.sortAlternate();
                }else{
                    this.sortDefault();
                }
            },
            sortDefault(){
                const legendsByQuarter = (this.chart.filters.chartType === 'growth')  ? this.chartLegend: this.sortObjectByQuarter(this.chartLegend);

                this.groupedChartLegend = {};

                    for (let i = 0; i < legendsByQuarter.length; i++) {
                        let legend = legendsByQuarter[i];
                        //check if the key exists
                        if (this.groupedChartLegend[legend.name] === undefined) {
                            // if not create it
                            this.groupedChartLegend[legend.name] = [];
                        }
                        //push element to array
                        this.groupedChartLegend[legend.name].push(legend);
                    }

                },
            sortAlternate(){

                this.groupedChartLegend = {};

                if (this.chart.filters.chartType === 'growth') {
                    for (let i = 0; i < this.chartLegend.length; i++) {
                        let legend = this.chartLegend[i];

                        //check if the key exists
                        if (this.groupedChartLegend[legend.name] === undefined) {
                            // if not create it
                            this.groupedChartLegend[legend.name] = [];
                        }
                        //push element to array
                        this.groupedChartLegend[legend.name].push(legend);
                    }
                }else{

                    // sort by company and group together
                    if (this.chart.filters.cumulativeType === 'none') {
                        for (let i = 0; i < this.chartLegend.length; i++) {
                            let legend = this.chartLegend[i];
                            //there are some gouped companies with a "," separator
                            let companyGroup = legend.company_name.split(" , ");

                            if (companyGroup.length) {
                                for (let i = 0; i < companyGroup.length; i++) {
                                    let companyGroupName = companyGroup[i].toLowerCase();

                                    //check if the key exists
                                    if (this.groupedChartLegend[companyGroupName] === undefined) {
                                        // if not create it
                                        this.groupedChartLegend[companyGroupName] = [];
                                    }

                                    //push element to array
                                    this.groupedChartLegend[companyGroupName].push(legend);
                                    //sort brands alphabetically
                                    this.groupedChartLegend[companyGroupName].sort((a, b) => (a.brands_name.toLowerCase() > b.brands_name.toLowerCase()) ? 1 : -1);
                                }
                            }
                        }
                        // sort the companies alphabetically
                        this.groupedChartLegend = this.sortObject(this.groupedChartLegend );

                    }else{

                        // in this case sort alphabetically by the items name
                        let legendsByQuarter ={};
                         legendsByQuarter =   this.chartLegend.sort((a, b) => (a.brands_name.toLowerCase() > b.brands_name.toLowerCase()) ? 1 : -1)
                        this.groupedChartLegend = {};

                         // reformat to comply to standar structure
                        for (let i = 0; i < legendsByQuarter.length; i++) {
                            let legend = legendsByQuarter[i];
                            //check if the key exists
                            if (this.groupedChartLegend[legend.name] === undefined) {
                                // if not create it
                                this.groupedChartLegend[legend.name] = [];
                            }
                            //push element to array
                            this.groupedChartLegend[legend.name].push(legend);
                        }
                    }

                }
            },
            formatLoeDate(limited_loe, full_loe){
                if(limited_loe === null && full_loe === null )
                    return null;
                
                let res = "";

                if(limited_loe !== null){
                    res += limited_loe['month'] !== null? dateUtil.getMonthShortName(limited_loe['month']) : '?';
                    res += ' ' + dateUtil.getYearShortName(limited_loe.year) + ' / ';
                }

                if(full_loe !== null){
                    res += full_loe['month'] !== null? dateUtil.getMonthShortName(full_loe['month']) : '?';
                    res += ' ' + dateUtil.getYearShortName(full_loe.year);
                } else {
                    res +=  '?'
                }
                
                return res;
            },
            getChartLegend() {
                this.legendSort= this.defaultLegendSort;
                this.showLoe = this.defaultShowLoe;
                this.colorByFicBic = this.defaultColorByFicBic;

                const entityType = this.chart.filters.chartType === 'growth' ? 'Growth rate' : 'Drug';
                let {data, events, ficBicData} = this.chart;

                if (this.chart.filters.chartType === 'growth') {
                    data = Object.keys(data)
                        .filter(dataKey => data[dataKey].length > 0)
                        .reduce((total, dataKey) => Object.assign(total, {[dataKey]: data[dataKey]}), {});
                }

                this.chartLegend = Object.keys(data).map((dataKey) => {
                    const legend = {id: dataKey, type: entityType};
                    if (this.isGrowthRateGraph) {
                        const foundGrowthRate = filters.growthRates.find(growthRate => growthRate.value === dataKey);
                         legend.name = foundGrowthRate ? foundGrowthRate.text : 'Unknown growth rate';
                    } else if (!data[dataKey][0].drug_brand_name) {
                        legend.brands_name = legend.name = `${legend.type} removed`;
                    } else {
                        legend.name = `${data[dataKey][0].drug_brand_name.brand_name} (${data[dataKey][0].company.name})`;
                        legend.brands_name = data[dataKey][0].drug_brand_name.brand_name;
                        legend.company_name = data[dataKey][0].company.name;
                        // in this case we need the las quarter
                        legend.last_quarter_revenue = data[dataKey][data[dataKey].length-1].revenue;

                        legend.is_fic_bic_colored = false;
                        if(this.colorByFicBic && ficBicData != null){
                            
                            const drugBrand = data[dataKey][0];

                            legend.ficBicData = Object.values(ficBicData)
                                .filter((data)=>data.drug_id == drugBrand.drug_brand_name.drug_id && ((drugBrand.drug_brand_name.group_revenue && data.group_revenue) || data.id == drugBrand.drug_brand_id))
                                .map((data) => { 
                                    const fic_class = Object.values(data.classes).find((e)=> e.fic_from != null && e.fic_to == null); 
                                    const bic_class = Object.values(data.classes).find((e)=> e.bic_from != null && e.bic_to == null); 
                                    return {
                                        id: dataKey,
                                        brand_name: data.brand_name,
                                        is_fic : fic_class != undefined,
                                        is_bic : bic_class != undefined,
                                        is_fic_bic : 
                                            fic_class != undefined
                                            && bic_class != undefined
                                            && fic_class.id == bic_class.id,
                                    };
                                });
                          
                            legend.is_fic_bic_colored = legend.ficBicData
                                .findIndex((e)=>e.is_fic || e.is_bic) >= 0
                        }
                    }

                    return legend;
                });

                if(this.showLoe){
                    Object.keys(events).forEach((eventKey) => {
                        if(events[eventKey].loe_dates == null)
                            return;

                        const loeEvents = events[eventKey].loe_dates;

                        const chartLegendIndex = this.chartLegend.findIndex((e)=>e.id.startsWith(events[eventKey].id+"_"));
                        if(chartLegendIndex<0) return;
                        this.chartLegend[chartLegendIndex]={
                            ...this.chartLegend[chartLegendIndex],
                            loe_dates : loeEvents.map((e)=>{
                                    return {
                                        ...e,
                                        id: e.id,
                                        brand_name: e.brand_name,
                                        loe_date: this.formatLoeDate(e.limited_loe, e.full_loe)
                                    };
                                })
                        }
                    });
                }

                this.updateLegendSorting();

            },
            sortObject(obj) {
                return Object.keys(obj).sort().reduce(function (result, key) {
                    result[key] = obj[key];
                    return result;
                }, {});
            },
            sortObjectByQuarter(obj) {
             return   obj.sort((a, b) => (Number(a.last_quarter_revenue) < Number(b.last_quarter_revenue)) ? 1 : -1)
            },
            legendItemClick(id) {
                this.chart.drawingService.lineClickEvent(id);
            },
            getLineColor(legend, dataIndex) {
                if(this.colorByFicBic && legend.ficBicData){
                    if(dataIndex == undefined){                     
                        const ficBrand = legend.ficBicData.find((e)=>e.is_fic);
                        const bicBrand = legend.ficBicData.find((e)=>e.is_bic);

                        // one brand is_fic & another is_bic OR same brand is_fic & is_bic
                        if(ficBrand !== undefined && bicBrand !== undefined){
                            return this.userSettings.fic_bic_color;
                        }

                        if(ficBrand){
                            return this.userSettings.fic_color;
                        }
                        
                        if(bicBrand){
                            return this.userSettings.bic_color;
                        }
                    }else{
                        const data = legend.ficBicData[dataIndex];
                        if(data.is_fic_bic) return this.userSettings.fic_bic_color;
                        if(data.is_fic) return this.userSettings.fic_color;
                        if(data.is_bic) return this.userSettings.bic_color;
                    }
                   
                }
                
                return this.allLinesColors[legend.id];
            },
            handleOnModifyLoe(id, date){
                this.$emit('modifyLoe',id, date)
            },
        },
    };

</script>

<style lang="scss">
    @import '../../../style/Charts/ViewChart/LegendComponent.scss';
</style>
